module.exports = require("ngx-bootstrap/component-loader");